// @flow

import { useDispatch } from 'react-redux';

import { approveContract, selectContracts } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useAppSelector } from '../../../../hooks/useAppSelector';

import styles from './ContractsButton.scss';

export function ContractsButton(): React.MixedElement {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const contracts = useAppSelector(selectContracts);

  const allContractsApproved = contracts.every(contract => contract.isApproved);

  const handleSelectAllContracts = (evt: any) => {
    evt.preventDefault();

    contracts.forEach(contract => {
      dispatch(
        approveContract({
          identifier: contract.identifier,
          isApproved: true,
        }),
      );
    });
  };
  return (
    <div
      className={
        allContractsApproved ? styles.hideAcceptAllContracts : undefined
      }
    >
      <Button small onClick={handleSelectAllContracts}>
        {__('Accept All')}
      </Button>
    </div>
  );
}
